'use client';

import { useQueryStates } from 'nuqs';
import { omit } from 'lodash-es';

import { getSearchFilterSearchParams, SEARCH_FILTER_SEARCH_PARAMS } from '~/lib/nuqs/search-filter-client';

export const useSearchFilterSearchParamsClient = () => {
  const [query, setQuery] = useQueryStates(SEARCH_FILTER_SEARCH_PARAMS);

  const searchFilterSearchParams = getSearchFilterSearchParams(query);

  const searchFilterSearchParamsWithoutQ = omit(searchFilterSearchParams, ['q']);

  return {
    searchParams: searchFilterSearchParams,
    setSearchParams: setQuery,
    hasSearchFilter: Object.keys(searchFilterSearchParamsWithoutQ).length > 0,
  };
};
